export default __webpack_public_path__ + "static/property-9-353x230-ed09c4764ceb7b6943efefbf88ef1a35.jpg";